/**
 * Поля описателя объекта. Модуль для работы с API.
 * @module definitionFields
 */

/**
 *  Получение списка полей описателя
 * @param {string} id - идентификатор описателя
 * @param {boolean} self - флаг для получения только своих полей
 * @returns {Promise} - список полей
 * @throws {Error} - ошибка при загрузке данных
 */
export const getDefinitionFields = async (id, self = false) => {
  try {
    const response = await fetch(
      `/api/definitionfields?descriptor=${id}&self=${self}`
    );

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error("Ошибка при загрузке данных. Попробуйте снова.");
    }

    return data.elementFields.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Создание поля
 * @param {object} item - данные поля
 * @returns {Promise} - созданное поле
 * @throws {Error} - ошибка при создании данных
 */
export const createField = async (item) => {
  try {
    const response = await fetch("/api/definitionfield", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.field;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление поля
 * @param {object} item - данные поля
 * @param {string} item.uuid - идентификатор поля
 * @param {string} item.name - название поля
 * @param {string} item.description - описание поля
 * @returns {Promise} - обновленное поле
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateField = async (item) => {
  try {
    const response = await fetch("/api/definitionfield", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.field;
  } catch (err) {
    throw err;
  }
};

/**
 * Удаление поля
 * @param {object} item - данные поля
 * @returns {Promise} - удаленное поле
 * @throws {Error} - ошибка при удалении данных
 */
export const deleteField = async (item) => {
  try {
    const response = await fetch("/api/definitionfield", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при удалении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};
